__turbopack_context__.v({
  "button": "bookmarkCard-module-scss-module__7RzYjW__button",
  "buttonContainer": "bookmarkCard-module-scss-module__7RzYjW__buttonContainer",
  "card": "bookmarkCard-module-scss-module__7RzYjW__card",
  "description": "bookmarkCard-module-scss-module__7RzYjW__description",
  "title": "bookmarkCard-module-scss-module__7RzYjW__title",
});
